import { useEffect, useState } from "react";
import { MessageSquare } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Link } from "react-router-dom";

export default function MessagesBell() {
  const { user } = useAuth();
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!user || user === false) return;
    const load = async () => {
      try {
        const { data } = await api.get("/messages/unread-count");
        setCount(data.count);
      } catch {}
    };
    load();
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, [user]);

  if (!user || user === false) return null;
  return (
    <Link
      to="/messages"
      className="relative p-2 rounded-full hover:bg-[#F9EFE6] transition"
      data-testid="messages-bell"
      aria-label="Messages"
    >
      <MessageSquare className="w-5 h-5 text-[#3B2C24]" />
      {count > 0 && (
        <span
          data-testid="messages-count"
          className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-[#FF7E67] text-white text-[10px] font-semibold grid place-items-center"
        >
          {count > 9 ? "9+" : count}
        </span>
      )}
    </Link>
  );
}
